import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getReviewees.operation = 'READ';
export function getReviewees() {
    return get(`${API_URL}/reviews/reviewees/me`);
}
